export default __webpack_public_path__ + "static/media/club_logo_512x512.7305efda.png";